import React, { useRef, useEffect, useCallback, useState} from 'react';

const TIMEOUT = 250;

export const useTransformationTooltip = () => {
    const [showTooltip, setShowTooltip] = useState(undefined);
    const hovering = useRef(false);

    const onMouseOver = useCallback((e, transformation) => {
        hovering.current = transformation;
        setTimeout(() => {
            if (hovering.current === transformation) {
                setShowTooltip(transformation);
            }
        }, TIMEOUT);
    }, [setShowTooltip]);

    const onMouseLeave = useCallback((e, transformation) => {
        hovering.current = false;
        setShowTooltip(undefined);
    }, [setShowTooltip]);
    
    return {showTooltip, onMouseOver, onMouseLeave};
};
    
